import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/contexts/LanguageContext";
import "@/index.css";
import App from "@/App";
import PublicSchoolProfile from "@/pages/PublicSchoolProfile";
import FeatureMarketingPage from "@/pages/FeatureMarketingPage";
import AdmissionEngineLandingPage from "@/pages/AdmissionEngineLandingPage";
import PlatformSetupPage from "@/pages/PlatformSetupPage";
import { PrivacyPolicy, TermsConditions, RefundPolicy, ContactUs, AboutUs } from "@/pages/LegalPages";
import LegalPageLayout from "@/components/LegalPageLayout";

// Wrapper component to extract subdomain from URL
function PublicSchoolProfileWrapper() {
  const subdomain = window.location.pathname.split('/')[2];
  return <PublicSchoolProfile subdomain={subdomain} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <LanguageProvider>
    <BrowserRouter>
      <Routes>
        {/* Public Feature Marketing Pages for Ads - Each AI feature has unique URL */}
        <Route path="/feature/:featureId" element={<FeatureMarketingPage />} />
        
        {/* Public Admission Engine Landing Page - canonical URL is /admission */}
        <Route path="/admission" element={<AdmissionEngineLandingPage />} />
        <Route path="/admission-engine-info" element={<Navigate to="/admission" replace />} />
        
        {/* Public School Profile */}
        <Route path="/school/:subdomain" element={<PublicSchoolProfileWrapper />} />
        
        {/* One-Time Platform Admin Setup */}
        <Route path="/setup" element={<PlatformSetupPage />} />
        
        {/* Legal Pages with Layout */}
        <Route path="/privacy" element={<LegalPageLayout><PrivacyPolicy /></LegalPageLayout>} />
        <Route path="/terms" element={<LegalPageLayout><TermsConditions /></LegalPageLayout>} />
        <Route path="/refund" element={<LegalPageLayout><RefundPolicy /></LegalPageLayout>} />
        <Route path="/contact" element={<LegalPageLayout><ContactUs /></LegalPageLayout>} />
        <Route path="/about" element={<LegalPageLayout><AboutUs /></LegalPageLayout>} />
        
        {/* All other routes go to main App */}
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
    </LanguageProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
